import React from 'react';
import { Tag } from '@instructure/ui-tag';
import { Text } from '@instructure/ui-text';
import { Tooltip } from '@instructure/ui-tooltip';
import { Flex } from '@instructure/ui-flex';
import { IconAddSolid, IconXSolid } from '@instructure/ui-icons';
import { InstUISettingsProvider } from '@instructure/emotion';
import { TruncateText } from '@instructure/ui-truncate-text';
import t from 'format-message';
var componentOverrides = {
  Tag: {
    defaultBackground: 'white'
  }
};
var ellipsis = function ellipsis() {
  return t('…');
};
var truncate = function truncate(text) {
  return text.length > 14 ? text.slice(0, 13) + ellipsis() : text;
};
function renderText(text, truncatedText, textColor) {
  var isTruncated = text.length > truncatedText.length;
  if (isTruncated) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      renderTip: text
    }, /*#__PURE__*/React.createElement(Text, {
      as: "div",
      color: textColor
    }, /*#__PURE__*/React.createElement(TruncateText, null, truncatedText)));
  } else {
    return /*#__PURE__*/React.createElement(Text, {
      as: "div",
      color: textColor
    }, /*#__PURE__*/React.createElement(TruncateText, null, text));
  }
}
function renderIcon(selected) {
  if (selected) {
    return /*#__PURE__*/React.createElement(IconXSolid, {
      "data-testid": "item-selected"
    });
  } else {
    return /*#__PURE__*/React.createElement(IconAddSolid, {
      "data-testid": "item-unselected",
      color: "brand"
    });
  }
}
var Pill = function Pill(_ref) {
  var studentId = _ref.studentId,
    observerId = _ref.observerId,
    text = _ref.text,
    _onClick = _ref.onClick,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected;
  var textColor = selected ? 'primary' : 'secondary';
  var truncatedText = truncate(text);
  var testId = observerId ? 'observer-pill' : 'student-pill';
  var ariaLabel = selected ? t('Remove { text }', {
    text: text
  }) : t('Add { text }', {
    text: text
  });
  var contents = /*#__PURE__*/React.createElement(Flex, {
    as: "div",
    margin: "0 xxx-small 0 0",
    justifyItems: "space-between"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    size: "0.75rem",
    shouldGrow: true,
    margin: "0 xx-small 0 0",
    overflowX: "hidden",
    "aria-label": ariaLabel
  }, renderText(text, truncatedText, textColor)), /*#__PURE__*/React.createElement(Flex.Item, {
    padding: "0 0 xxx-small 0"
  }, renderIcon(selected)));
  return /*#__PURE__*/React.createElement(InstUISettingsProvider, {
    theme: {
      componentOverrides: componentOverrides
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    text: contents,
    "data-testid": testId,
    onClick: function onClick() {
      if (observerId !== void 0) {
        _onClick(studentId, observerId);
      } else {
        _onClick(studentId);
      }
    }
  }));
};
export default Pill;